import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { HttpStatusCodes } from '../enums/HttpStatusCodes';
import { MONITORING_MESSAGES } from '../enums/monitoring.enum';
import { CreceMasService } from '../services/crece-mas.service';
import { MonitoringService } from '../services/monitoring/monitoring.service';
import { SharedServiceService } from '../services/shared-service.service';

@Injectable()
export class HttpErrorRulesInterceptor implements HttpInterceptor {

  constructor(
    private readonly injector: Injector,
  ) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isApiRequest(request)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error): Observable<HttpEvent<any>> => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === HttpStatusCodes.NOT_ACCEPTABLE.code) {
            return from(this.forceLogout()).pipe(
              switchMap(() => throwError(() => error))
            );
          }
        }
        return throwError(() => error);
      })
    );
  }

  private isApiRequest(request: HttpRequest<any>): boolean {
    const apiEndpoints = [environment.urlApiV2];
    return apiEndpoints.some(endpoint => request.url.startsWith(endpoint));
  }

  /**
   * Fuerza el cierre de sesión del usuario
   */
  private async forceLogout() {
    const monitoringService = this.injector.get(MonitoringService);
    const creceMasService = this.injector.get(CreceMasService);
    const sharedServiceService = this.injector.get(SharedServiceService);

    monitoringService.captureMessage(MONITORING_MESSAGES.AUTH.CHANGE_PASSWORD);
    monitoringService.setUser(null);

    await creceMasService.cerrarSesionCreceMas();
    await sharedServiceService.clearData('home');
  }
}